import './Products.css'
import React from 'react'
import Footer from '@components/Common/Footer/Footer'
import Header from '@components/Common/Header/Header'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import borrwin from '../../Assets/Images/borrrowimage.jpg'
import lender from '../../Assets/Images/lenderimage.jpg'


const Products = () => {
    const handleMenuToggle = () => { };
    return (
        <>
            <section className="banner-section inner-banner-section">
                <div className="container">
                    <Header handleMenuToggle={handleMenuToggle} />
                    <Breadcrumb className='mt-5'>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>

                        <Breadcrumb.Item active>Our Products</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="banner banner_inner ">
                        <h3>
                            Our <span className="instant">Products</span>
                        </h3>
                        <p className='text-light mb-0'>Innovative Financial Solutions for Borrowing and Lending.</p>
                        <p className='text-light mb-0'>Our platform offers a range of financial products designed to empower individuals and businesses through transparency, simplicity, and flexibility. Whether you are seeking funding or exploring investment opportunities,  we provide tools and solutions tailored to your needs. </p>

                    </div>
                </div>
            </section>

            <section className="our-products">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 align-items-center d-flex">
                            <div className="our-products-item pb-0">
                                <h3 className='mb-4 work-heading'>Borrow – Fast, Flexible Loans for Personal or Business Needs </h3>
                                <p>When you need funding without the hassle of traditional processes, our borrowing solutions offer a seamless experience. We provide quick, unsecured loans suitable for personal and small business purposes. The application process is fully online, making it straightforward and accessible. Rather than focusing solely on credit scores, we take a holistic view of your financial profile, including your income, financial habits, and background.</p>
                                <p className='ourloan'>Our loan offers are designed for clarity—transparent interest rates, upfront fees, and flexible terms ensure there are no hidden surprises. This fair lending approach is crafted to provide the support you need to achieve your goals. </p>
                            </div>
                        </div>
                        <div className="col-md-4 align-items-center d-flex">
                            <img src={borrwin} alt="" className='img-fluid rounded-4 borrow-lend' />
                        </div>
                    </div>
                </div>
            </section>
            <section className='our-products-bottom'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 order-1 order-md-0 borrow-lend img-borrow align-items-center d-flex">
                            <img src={lender} alt="" className='img-fluid rounded-4 ' />

                        </div>
                        <div className="col-md-8 order-0 order-md-1 align-items-center d-flex ">
                            <div className="our-products-item">
                                <h3 className='mb-4 work-heading lend-invest'>Lend – Invest with Purpose, Earn with Confidence </h3>
                                <p>Become a lender and earn competitive returns by investing directly in verified borrowers. With annual returns typically ranging from 5–8% after defaults, our platform allows you to build wealth while supporting others. Whether you want to invest £100 or £100,000, you have the freedom to choose specific loans or leverage our Auto-Invest tool to diversify your portfolio across various risk levels.  </p>
                                <p className='ourloan'>Monthly repayments—including principal and interest—are deposited back into your account, providing the option to reinvest or withdraw. This structured approach combines purpose-driven investment with financial growth, giving you confidence in every transaction.  </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Products
